export enum DealUpdateTypeId {
  DEAL_STP_UPDATE,
  DEAL_CONFIRMED,
  DEAL_CANCELLED,
  FILL_PENDING_DEAL_CANCELLED,
  Deal_SMS_EMAIL,
  DEAL_OPS_CLEARED,
  DEAL_FILL_CANCELLED,
  NONE,
  DEAL_FILL_COMMENT,
  DEAL_INITIAL_FILL,
}

export namespace DealUpdateTypeId {
  let elements = [
    DealUpdateTypeId.DEAL_STP_UPDATE,
    DealUpdateTypeId.DEAL_CONFIRMED,
    DealUpdateTypeId.DEAL_CANCELLED,
    DealUpdateTypeId.FILL_PENDING_DEAL_CANCELLED,
    DealUpdateTypeId.Deal_SMS_EMAIL,
    DealUpdateTypeId.DEAL_OPS_CLEARED,
    DealUpdateTypeId.DEAL_FILL_CANCELLED,
    DealUpdateTypeId.NONE,
    DealUpdateTypeId.DEAL_FILL_COMMENT,
    DealUpdateTypeId.DEAL_INITIAL_FILL,
  ];
  let alias = "com.bcdfx.model.DealUpdateTypeId";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
